export const FLAGS = {
    REGISTERED_USER_STATUS: ["P", "NR", "D"]
}